import React, { useEffect, useState } from "react";
import { EventCard } from "./Event/EventCard";
import { getCards } from "../../../_api/Event";
import { useOutletContext } from "react-router-dom";
import { getEventStatus } from "../../../_helpers/functions";

const TabsMenu = [
    {
        name: "En cours d'organisation",
        ancre: "PENDING",
    },
    { name: "Annulé", ancre: "CANCELLED" },
    { name: "Historique", ancre: "CLOSED" },
];

export const Home = () => {
    const [user, setUser, currentApp, currentMenu] = useOutletContext();
    const [events, setEvents] = useState([]);
    const [activeTab, setActiveTab] = useState("PENDING");

    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["MAIN"]["features"];

    useEffect(() => {
        getCards().then((resp) => {
            const eventsData = resp.data.map((data) => {
                const status = getEventStatus(data);
                data["status"] = status;
                return data;
            });
            const filteredEvents = eventsData.filter((event) => {
                const groupIds = user.groups.map((group) => group.id);

                const count_shift = event.shifts.filter((creneau) => {
                    if (!creneau.skill_id || features_right["admin_view"] || user.skills.some(s => s.id === creneau.skill_id)) {
                        return creneau;
                    }
                });

                if (count_shift.length > 0) {
                    return (
                        event.status[activeTab] &&
                        groupIds.includes(event.group.id)
                    );
                }
            });
            const sortedEvents = filteredEvents.sort((a, b) => {
                const minA = new Date(Math.min(...a.shifts.map(s => new Date(s.start_time))));
                const minB = new Date(Math.min(...b.shifts.map(s => new Date(s.start_time))));
                return minA - minB;
            });

            setEvents(sortedEvents);
        });
    }, [activeTab]);

    return (
        <div className="w-full bg-gray-100">
            <div className="flex justify-center p-4 bg-white shadow-md">
                <div className="text-center">
                    <nav className="flex space-x-4 text-gray-500">
                        {TabsMenu.map((tab, idx) => {
                            return (
                                <a
                                    key={idx}
                                    href={"#" + tab.ancre}
                                    className={
                                        tab.ancre === activeTab
                                            ? "no-underline text-black font-semibold border-b-2 border-black pb-1"
                                            : "no-underline hover:text-black text-black font-semibold "
                                    }
                                    onClick={() => setActiveTab(tab.ancre)}
                                >
                                    {tab.name}
                                </a>
                            );
                        })}
                    </nav>
                </div>
            </div>

            <div className="container mx-auto py-10 px-4">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {events.map((event) => {
                        return <EventCard key={event.id} event={event} />;
                    })}
                </div>
                {events.length === 0 && (
                    <div className="w-full flex justify-center align-center bg-white p-4 rounded-lg">
                        Il n'y a aucun évènement pour l'instant.
                    </div>
                )}
            </div>
        </div>
    );
};
